import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { getMsalInstance, initializeMsal } from './auth/msalInstance.js';
import { resetSavedFiltersOnce } from './utils/cookies.js';
import App from './App';
import './index.css';

resetSavedFiltersOnce();

const msalInstance = getMsalInstance();

try {
  await initializeMsal();
} catch (error) {
  console.error('Failed to initialize MSAL:', error);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
